 
import { useState, useEffect } from "react";
 
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import burceMars from "assets/images/dummy-logo.png";
import backgroundImage from "assets/images/bg-image.jpg"; 
import axios from "axios";
import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { func } from "prop-types";
import { useDispatch } from "react-redux";
import { setYojnaId } from "app/yojnaIdManagementSlice";

function Header({ children }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    const fetchYojnaDepartment = async () => {
      const access_token =
        localStorage.getItem("access_token") || sessionStorage.getItem("access_token");
      const user_role = localStorage.getItem("user_role") || sessionStorage.getItem("user_role");

      if (!access_token || !user_role) {
        console.error("❌ Access token or Role ID missing!");
        return;
      }

      try {
        const response = await axios.get(
          `https://telelawmh.in/apiv2collectorapp/public/api/yojna-department`,
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
              "Content-Type": "application/json",
              RoleID: user_role,
            },
          }
        );

        console.log("✅ API Response:", response.data.departments);
        setDepartments(response.data.departments); // ✅ Store data in state
      } catch (error) {
        console.error("❌ API Error:", error.response ? error.response.data : error.message);
      }
    };

    fetchYojnaDepartment();
  }, []);

  const renderToSubyojnaPage = (yojna_department_id) => {
    dispatch(setYojnaId(yojna_department_id)); 
    console.log("yojna_department_id", yojna_department_id);
    navigate("/subyojana");
  };
 
  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        sx={{
          position: "relative",
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar src={burceMars} alt="profile-image" size="xl" shadow="sm" />
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h2" fontWeight="medium">
                विभाग 
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
                <Tab
                  label="App"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      home
                    </Icon>
                  }
                />
                <Tab
                  label="Message"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      email
                    </Icon>
                  }
                />
                <Tab
                  label="Settings"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      settings
                    </Icon>
                  }
                />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid> 
          <MDBox sx={{ flexGrow: 1, padding: 2 }}>
            <Grid container spacing={2}>
              {departments.map((dept, index) => (
                <Grid item xs={12} md={4} key={index}> {/* ✅ xs=12 for mobile, md=4 for larger screens */}
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      my: 1,
                      py: 3,
                      fontSize: "1.2rem",
                      color: "#dddddd",
                      background: "linear-gradient(135deg, #1e3c72 10%, #2a5298 100%)",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        background: "linear-gradient(135deg, #2a5298 10%, #1e3c72 100%)",
                      },
                    }}
                    onClick={() => renderToSubyojnaPage(dept.yojna_department_id)}
                  > 
                    {dept.yojna_department_title}
                  </Button>
                </Grid>
              ))}
            </Grid> 
          </MDBox> 
      </Card>
    </MDBox>
  );
}

export default Header;
